export enum AdminRouteNames {
  PREFIX = 'sy/yonetim',
  ALL = '*',
  HOME = 'reports',
  PRODUCT = 'product',
  SLIDER = 'slider',
  CATEGORY = 'category',
  ORDER = 'order',
  USER = 'user',
  SETTING = 'setting',
  CORPORATEL_IDENTITY = 'corporate',
  ACCOUNT = 'account',
  POST = 'create-post-seo',
  FILES = 'files',
}
